import React, { useState } from 'react';
import {
  Box,
  Button,
  Paper,
  Table,
  TextField,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  FormControl,
  Select,
  MenuItem,
  Grid,
  InputLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
} from '@material-ui/core';

export default function RefundReceipt() {
  const [receiptType, setReceiptType] = useState('refund');
  const [accountNo, setAccountNo] = useState('');
  const [detailsFetched, setDetailsFetched] = useState(false);

  const handleGoClick = () => {
    // TODO: Fetch details by accountNo
    if (accountNo === '') {
      alert('Please enter Account No');
      return;
    }
    setDetailsFetched(true);
  };

  return (
    <Box p={2}>
      <Typography variant="h6" color="primary">
        Generate Receipt
      </Typography>

      <Grid container spacing={2} alignItems="center" justifyContent="space-between">
        {/* Receipt Type */}
        <Grid item xs={12} md={6}>
          <RadioGroup row value={receiptType} onChange={e => setReceiptType(e.target.value)}>
            <FormControlLabel value="new" control={<Radio />} label="New Receipt" />
            <FormControlLabel value="reverse" control={<Radio />} label="Reverse Receipt" />
            <FormControlLabel value="refund" control={<Radio />} label="Refund Receipt" />
          </RadioGroup>
        </Grid>

        {/* Account No Input */}
        <Grid item>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} sm={4}>
              <Typography style={{ color: 'red' }}>* Account No</Typography>
            </Grid>
            <Grid item xs={12} sm={5}>
              <TextField fullWidth size="small" value={accountNo} onChange={e => setAccountNo(e.target.value)} />
            </Grid>
            <Grid item xs={12} sm={3}>
              <Button variant="contained" fullWidth onClick={handleGoClick}>
                GO
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      {/* Receipt Type Selector */}

      {detailsFetched && (
        <Box mt={3}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              {/* Party Name */}
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={4}>
                  <Typography>
                    <b>Party Name:</b>
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <Typography>SBI General Insurance Company Ltd</Typography>
                </Grid>
              </Grid>

              {/* Amount */}
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={4}>
                  <Typography>
                    <b>Amount:</b>
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <Typography>277839.18</Typography>
                </Grid>
              </Grid>

              {/* SBIG Branch Code */}
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={4}>
                  <Typography>
                    <b>SBIG Branch Code:</b>
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <Typography>SBI General Insurance Company Ltd - Chennai (00010)</Typography>
                </Grid>
              </Grid>

              {/* Balance Amount */}
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={4}>
                  <Typography>
                    <b>Balance Amount:</b>
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <Typography>277839.18</Typography>
                </Grid>
              </Grid>

              {/* Amount After Refund */}
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={4}>
                  <Typography>
                    <b>Amount After Refund:</b>
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <Typography>-</Typography> {/* Put actual value here if needed */}
                </Grid>
              </Grid>

              {/* Note (TextField) */}
              <Grid container spacing={2} alignItems="flex-start" mt={1}>
                <Grid item xs={4}>
                  <Typography>
                    <b>
                      {' '}
                      <span style={{ color: 'red' }}>*</span> Note:
                    </b>
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <TextField fullWidth multiline rows={3} placeholder="Enter note here" size="small" />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={6}>
              {/* Effective Date */}
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={4}>
                  <Typography>
                    <b>Effective Date:</b>
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <Typography>2024-09-13</Typography>
                </Grid>
              </Grid>

              {/* Payer */}
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={4}>
                  <Typography>
                    <b>Payer:</b>
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <Typography>Cholamandalam Investment And Finance Company Ltd</Typography>
                </Grid>
              </Grid>

              {/* Mode of Payment */}
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={4}>
                  <Typography>
                    <b>Mode of Payment:</b>
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <Typography>EFT</Typography>
                </Grid>
              </Grid>

              {/* Refund Amount */}
              <Grid container spacing={2} alignItems="center" mt={1}>
                <Grid item xs={4}>
                  <Typography>
                    <b>
                      <span style={{ color: 'red' }}>*</span> Refund Amount:
                    </b>
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <TextField fullWidth size="small" placeholder="0.0" />
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Box style={{ display: 'flex', gap: '1rem', justifyContent: 'end' }} mt={3}>
            <Button variant="outlined" color="primary">
              Close
            </Button>
            <Button variant="contained" color="primary">
              Submit
            </Button>
          </Box>
        </Box>
      )}
    </Box>
  );
}
